import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { PublicLayout } from "@/components/layout/PublicLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import WhyMenaGroupFX from "@/pages/WhyMenaGroupFX";
import Markets from "@/pages/Markets";
import MarketPage from "@/pages/MarketPage";
import TradingPlatforms from "@/pages/TradingPlatforms";
import AccountSolutions from "@/pages/AccountSolutions";
import BrokerPartners from "@/pages/BrokerPartners";
import BrokerProfile from "@/pages/BrokerProfile";
import MarketAnalysis from "@/pages/MarketAnalysis";
import Article from "@/pages/Article";
import EconomicCalendar from "@/pages/EconomicCalendar";
import Education from "@/pages/Education";
import EducationArticle from "@/pages/EducationArticle";
import Partners from "@/pages/Partners";
import BecomePartner from "@/pages/BecomePartner";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import SearchPage from "@/pages/SearchPage";
import Legal from "@/pages/Legal";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import BrokersAdmin from "@/pages/admin/BrokersAdmin";
import ArticlesAdmin from "@/pages/admin/ArticlesAdmin";
import EducationAdmin from "@/pages/admin/EducationAdmin";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import ApplicationsAdmin from "@/pages/admin/ApplicationsAdmin";
import LegalAdmin from "@/pages/admin/LegalAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import CampaignsAdmin from "@/pages/admin/CampaignsAdmin";
import SubscribersAdmin from "@/pages/admin/SubscribersAdmin";
import PromotionsAdmin from "@/pages/admin/PromotionsAdmin";

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <LanguageProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<About />} />
              <Route path="/why-menagroupfx" element={<WhyMenaGroupFX />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/markets/:market" element={<MarketPage />} />
              <Route path="/trading-platforms" element={<TradingPlatforms />} />
              <Route path="/account-solutions" element={<AccountSolutions />} />
              <Route path="/broker-partners" element={<BrokerPartners />} />
              <Route path="/broker-partners/:slug" element={<BrokerProfile />} />
              <Route path="/market-analysis" element={<MarketAnalysis />} />
              <Route path="/market-analysis/:slug" element={<Article />} />
              <Route path="/economic-calendar" element={<EconomicCalendar />} />
              <Route path="/education" element={<Education />} />
              <Route path="/education/:slug" element={<EducationArticle />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/become-a-partner" element={<BecomePartner />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="brokers" element={<BrokersAdmin />} />
              <Route path="articles" element={<ArticlesAdmin />} />
              <Route path="education" element={<EducationAdmin />} />
              <Route path="leads" element={<LeadsAdmin />} />
              <Route path="applications" element={<ApplicationsAdmin />} />
              <Route path="campaigns" element={<CampaignsAdmin />} />
              <Route path="subscribers" element={<SubscribersAdmin />} />
              <Route path="promotions" element={<PromotionsAdmin />} />
              <Route path="legal" element={<LegalAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
          </BrowserRouter>
        </LanguageProvider>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
